"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classNames = require("classnames");
var PropTypes = require("prop-types");
var React = require("react");
var react_1 = require("react");
var patchIcon_1 = require("../../utils/patchIcon");
var propTypes = {
    label: PropTypes.string,
    indented: PropTypes.bool,
    icon: PropTypes.oneOfType([PropTypes.func, PropTypes.element])
};
/**
 * The `Benefit` component should be used to highlight insurance benefits.
 */
var Benefit = /** @class */ (function (_super) {
    __extends(Benefit, _super);
    function Benefit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Benefit.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, label = _a.label, icon = _a.icon, indented = _a.indented, other = __rest(_a, ["children", "className", "label", "icon", "indented"]);
        var patchedIcon;
        if (icon) {
            patchedIcon = patchIcon_1.default(icon, {
                className: 'ee_benefit__icon'
            });
        }
        var componentClassName = classNames('ee_benefit', className, {
            'ee_benefit--indented': !icon && indented
        });
        return (React.createElement("div", __assign({}, other, { className: componentClassName }),
            patchedIcon,
            React.createElement("dl", { className: "ee_benefit__information" },
                React.createElement("dt", { className: "ee_benefit__label" }, label),
                React.createElement("dd", { className: "ee_benefit__text" }, children))));
    };
    Benefit.propTypes = propTypes;
    Benefit.defaultProps = {
        label: undefined,
        icon: undefined,
        indented: false
    };
    return Benefit;
}(react_1.Component));
exports.Benefit = Benefit;
exports.default = Benefit;
//# sourceMappingURL=Benefit.js.map
